import React from 'react'
import { BrandLogoFavicon, IcoMoon } from '@usap/uicomponents'

const UpperContent = ({
  orderDetails,
  returnId,
}) => {
  const {
    merchant_order_id: orderNumber,
  } = { ...orderDetails }
  return (
    <div className="content">
      <div>
        <IcoMoon
          icon={BrandLogoFavicon}
          viewBox="100 -30 100 100"
        />
      </div>
      <div>
        <span>Lifetime Replacement Packing Slip</span>
        <span>Reference Number</span>
      </div>
      <div>{returnId}</div>
      <div>
        <span>Original Order Number</span>
      </div>
      <div>{orderNumber}</div>
    </div>
  )
}

export default UpperContent
